import React, {Component} from 'react';
import IcoinIcon from "../assets/images/icoin.png";

export default class ICoinIcon extends Component {
    render() {
         return <img height="15px" width="15px" src={require('../assets/images/icoin.png').default}></img>;
    }
}